export const CHART_HEIGHT = window.innerHeight
export const CHART_WIDTH = window.innerWidth
export const PROJ_STROKE_WIDTH = window.innerHeight / 330
export const CONNECTION_STROKE_WIDTH = PROJ_STROKE_WIDTH / 2.5
export const PROJ_MARGIN = PROJ_STROKE_WIDTH * 3.5

export const ROLES = ['dataviz', 'experience', 'dev', 'other']

export const PALETTE = ['#FF9970', '#37E7AC', '#9B6DFF', '#FF6B9D']
export const GAMMA_CORR = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  6,
  6,
  6,
  6,
  7,
  7,
  7,
  7,
  8,
  8,
  8,
  9,
  9,
  9,
  10,
  10,
  10,
  11,
  11,
  11,
  12,
  12,
  13,
  13,
  13,
  14,
  14,
  15,
  15,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  24,
  24,
  25,
  25,
  26,
  27,
  27,
  28,
  29,
  29,
  30,
  31,
  32,
  32,
  33,
  34,
  35,
  35,
  36,
  37,
  38,
  39,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  50,
  51,
  52,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  64,
  66,
  67,
  68,
  69,
  70,
  72,
  73,
  74,
  75,
  77,
  78,
  79,
  81,
  82,
  83,
  85,
  86,
  87,
  89,
  90,
  92,
  93,
  95,
  96,
  98,
  99,
  101,
  102,
  104,
  105,
  107,
  109,
  110,
  112,
  114,
  115,
  117,
  119,
  120,
  122,
  124,
  126,
  127,
  129,
  131,
  133,
  135,
  137,
  138,
  140,
  142,
  144,
  146,
  148,
  150,
  152,
  154,
  156,
  158,
  160,
  162,
  164,
  167,
  169,
  171,
  173,
  175,
  177,
  180,
  182,
  184,
  186,
  189,
  191,
  193,
  196,
  198,
  200,
  203,
  205,
  208,
  210,
  213,
  215,
  218,
  220,
  223,
  225,
  228,
  231,
  233,
  236,
  239,
  241,
  244,
  247,
  249,
  252,
  255,
]
export const EYE_CORR = [
  0,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  5,
  5,
  6,
  6,
  6,
  6,
  6,
  7,
  7,
  7,
  7,
  8,
  8,
  8,
  8,
  9,
  9,
  9,
  9,
  10,
  10,
  10,
  10,
  11,
  11,
  11,
  12,
  12,
  12,
  13,
  13,
  13,
  14,
  14,
  15,
  15,
  15,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  30,
  30,
  31,
  31,
  32,
  33,
  33,
  34,
  35,
  35,
  36,
  37,
  38,
  38,
  39,
  40,
  40,
  41,
  42,
  43,
  44,
  44,
  45,
  46,
  47,
  48,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  64,
  65,
  66,
  67,
  69,
  70,
  71,
  72,
  73,
  74,
  75,
  76,
  77,
  79,
  80,
  81,
  82,
  83,
  85,
  86,
  87,
  88,
  90,
  91,
  92,
  94,
  95,
  96,
  98,
  99,
  100,
  102,
  103,
  104,
  106,
  107,
  109,
  110,
  112,
  113,
  115,
  116,
  118,
  119,
  121,
  122,
  124,
  126,
  127,
  129,
  131,
  132,
  134,
  136,
  137,
  139,
  141,
  142,
  144,
  146,
  148,
  149,
  151,
  153,
  155,
  157,
  159,
  161,
  162,
  164,
  166,
  168,
  170,
  172,
  174,
  176,
  178,
  180,
  182,
  184,
  186,
  189,
  191,
  193,
  195,
  197,
  199,
  201,
  204,
  206,
  208,
  210,
  213,
  215,
  217,
  220,
  222,
  224,
  227,
  229,
  231,
  234,
  236,
  239,
  241,
  244,
  246,
  249,
  251,
  254,
]
export const LINE_TYPES = {
  project: 'project',
  connection: 'connection',
  firstLine: 'first-line',
  lastLine: 'last-line',
}

export const LINE_VELOCITY = 0.5

export const FILTER_TYPES = { proj: 'proj', ppl: 'ppl' }
